import dayjs from 'dayjs';

interface IDateTimeOptions {
  defaultValue?: string;
  formatType?: string;
}

function dateTime(value?: string | null, options?: IDateTimeOptions): string {
  if (!value) {
    return options?.defaultValue || '';
  }

  const dateTimeFormatted = dayjs(value).format(
    options?.formatType || 'DD/MM/YYYY - HH:MM',
  );

  return dateTimeFormatted;
}

export default dateTime;
